/*
 * Load application actions
 *
 * - loadApplication
 * - runAuthProvider
 */

// noinspection TypeScriptPreferShortImport
import { 
  Action, 
  OperationType, 
  Position, 
  ThemeLoad, 
  WarningType, 
  WindowType 
} from '../../dispatcher/Types';
import About from '../../components/layout/viewport/footer/about/About';
import ActiveSessions from '../../components/layout/viewport/footer/active_sessions/ActiveSessions';

export const maskTopLevelComponent: Action = [{
  evaluate: true,
  moduleName: '{topLevelComponentName}',
  type: OperationType.maskModule
}];

export const unmaskTopLevelComponent: Action = [{
  evaluate: true,
  moduleName: '{topLevelComponentName}',
  type: OperationType.unmaskModule
}];

/**
 * Load application if user is authenticated
 */
export const loadApplication: Action = [{
//   name: 'checkCookieConsent',
//   type: OperationType.action
// }, {
  load: ThemeLoad.change,
  type: OperationType.theme
}, {
  isCallback: false,
  isPromise: true,
  handleError: true,
  moduleName: 'AuthService',
  name: 'isAuthenticated',
  type: OperationType.addOperationData
}, {
  condition: '{isAuthenticated}',
  conditionOperations: [{
    isCallback: false,
    isPromise: true,
    mappingName: 'user',
    moduleName: 'AuthService',
    name: 'getUser'
  }, {
    name: 'getRefreshToken',
    type: OperationType.action
  }, {
    condition: '!{refresh_token}',
    conditionOperations: [{
      isCallback: false,
      isPromise: true,
      handleError: true,
      moduleName: 'AuthService',
      name: 'isUserValid',
      type: OperationType.addOperationData
    }],
    type: OperationType.conditional
  }, {
    condition: '{isUserValid} || {refresh_token}',
    conditionOperations: [{
      name: 'loadThemes',
      type: OperationType.action
    }, {
      connected: true,
      type: OperationType.webSocket
    }, {
      name: 'initializeApp',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}, {
  condition: '{isAuthenticated}',
  conditionOperations: [{
    args: ['interval'],
    moduleName: 'ActivityService',
    name: 'startTracking'
  }, {
    condition: '!({isUserValid} || {refresh_token})',
    conditionOperations: [{
      className: 'sm',
      items: [{
        operations: [],
        btnName: 'close',
        btnConfig: {
          pos: Position.end,
          themeColor: 'primary'
        }
      }],
      text: 'isUserValid.text',
      title: 'isUserValid.title',
      type: OperationType.warning,
      warningType: WarningType.error
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const openAbout: Action = [{
  children: [{
    render: About,
    propArgs: ['appVersion', 'appName']
  }],
  className: 'sm title-center footer-centered',
  items: [{
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }],
    btnName: 'Application.about.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }],
  placeholders: {
    template: {
      bind: {
        appName: '{appName}'
      }
    }
  },
  closable: true,
  title: 'Application.about.title',
  type: OperationType.dialog
}];

export const openActiveSessions: Action = [{
  data: {
    method: 'get',
    url: '/user/sessions'
  },
  mappingName: 'sessionsData',
  type: OperationType.request
}, {
  data: {
    template: {
      props: {
        bind: {
          sessionsCount: '{sessionsData.userSessions.length}'
        }
      }
    }
  },
  type: OperationType.data
}, {
  args: ['props'],
  moduleName: 'Footer',
  name: 'updateState'
}, {
  className: 'active-session lg',
  children: [{
    render: ActiveSessions,
    propArgs: ['sessionsData']
  }],
  items: [{
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }],
    btnName: 'Application.activeSessions.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      data: {
        method: 'post',
        url: '/user/sessions'
      },
      type: OperationType.request
    }, {
      data: {
        template: {
          props: {
            bind: {
              sessionsCount: 1
            }
          }
        }
      },
      type: OperationType.data
    }, {
      args: ['props'],
      moduleName: 'Footer',
      name: 'updateState'
    }, {
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }],
    btnName: 'Application.activeSessions.signOutAll',
    close: false,
    btnConfig: {
      accessibility: {
        ariaLabel: '',
        iconAriaHidden: true
      },
      className: 'k-error',
      themeColor: 'primary',
      pos: Position.end
    }
  }],
  // className: '',
  title: 'Application.activeSessions.title',
  type: OperationType.dialog
}];

export const signOutAll: Action = [{
  data: {
    isRest: false,
    url: '/signOutAll', // TODO set valid endpoint url
    method: 'get'
  },
  type: OperationType.request
}];
